export default "__VITE_PUBLIC_ASSET__1e2dc665__"